import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import semprocessoBanner from "../../../../assets/semprocesso-banner.svg";
import vibraBanner from "../../../../assets/vibra-banner.svg";
import pagdealBanner from "../../../../assets/pagdeal-banner.svg";
import arrow from "../../../../assets/arrow.svg";
import pagdealPartnership from "../../../../assets/pagdeal-partnership.png";

import "./index.scss";

const banners = [
  // { key: "semprocesso", image: semprocessoBanner, alt: "sem processo banner" },
  // { key: "first-arrow", image: arrow, alt: "arrow" },
  { key: "vibra", image: vibraBanner, alt: "vibra banner" },
  { key: "last-arrow", image: arrow, alt: "arrow" },
  { key: "pagdeal", image: pagdealBanner, alt: "pagdeal banner" },
];

const intervals = [2, 2, 2, 2];
const widths = [8, 114, 300, 486, 600];
let initialInterval = null;
let finalInterval = null;

export default function Loader({ proposalIsActive, isLoading, closeLoader }) {
  const [stepsLoading, setStepsLoading] = useState(0);
  const progressBarRef = useRef(null);
  const bannersRef = useRef(null);

  useEffect(() => {
    if (stepsLoading < 2) {
      initialInterval = setInterval(() => {
        setStepsLoading((prevStep) => prevStep + 1);
      }, 2000);
    }

    if (!isLoading) {
      finalInterval = setInterval(() => {
        setStepsLoading((prevStep) => prevStep + 1);
      }, 2000);
    } else {
      setStepsLoading((prevStep) => prevStep + 1);
    }

    return () => {
      clearInterval(initialInterval);
      clearInterval(finalInterval);
    };

    /* eslint-disable-next-line */
  }, [isLoading]);

  useEffect(() => {
    if (stepsLoading === 2) {
      clearInterval(initialInterval);
    }

    if (stepsLoading >= 6) {
      clearInterval(finalInterval);
      closeLoader();
    }

    /* eslint-disable-next-line */
  }, [stepsLoading]);

  const observer = useRef(
    new ResizeObserver(() => {
      handleDefineBannerOpacity();
    })
  );

  function handleDefineBannerOpacity() {
    const progressBarCurrent = progressBarRef.current;
    const bannersCurrent = bannersRef.current;

    if (progressBarCurrent && bannersCurrent) {
      const children = Array.from(bannersCurrent.children);
      const progressBarWidth = progressBarCurrent.getBoundingClientRect().width;
      children.forEach((item, index) => {
        if (index === 0 && progressBarWidth >= 104) {
          item.style.opacity = 1;
        }
        if (index === 1 && progressBarWidth >= 224) {
          item.style.opacity = 1;
        }
        if (index === 2 && progressBarWidth >= 290) {
          item.style.opacity = 1;
        }
        if (index === 3 && progressBarWidth >= 404) {
          item.style.opacity = 1;
        }
        if (index === 4 && progressBarWidth >= 476) {
          item.style.opacity = 1;
        }
      });
    }
  }

  useLayoutEffect(() => {
    const currentObserver = observer.current;
    const progressBarCurrent = progressBarRef.current;
    if (progressBarCurrent) {
      currentObserver.observe(progressBarCurrent);
    }

    return () => {
      currentObserver.disconnect();
    };
  }, [observer]);

  function returnClassName() {
    let className = "charge-home";

    if (!proposalIsActive) {
      className += " charge-home--rejected-proposal";
    }

    return className;
  }

  function returnSubtitle() {
    switch (stepsLoading) {
      case 0:
        return "Iniciando";
      case 1:
        return "Iniciando contato";
      case 2:
        return "Estabelecendo conexão";
      case 3:
        return "Carregando dados";
      default:
        return "Completo";
    }
  }

  if (stepsLoading >= 5) {
    return (
      <section className={returnClassName()}>
        <div className="charge-home__partnership">
          {/* <img src={pagdealPartnership} alt="pagdeal partnership" /> */}
          <h1>Pronto para começar!</h1>
          <p>O sistema iniciará em alguns segundos</p>
          <footer>
            Estamos estabelecendo a conexão entre os servidores da plataforma
            com a Vibra e em segundos carregaremos uma página para que você
            possa visualizar todas as suas dívidas
          </footer>
        </div>
      </section>
    );
  }

  return (
    <section className={returnClassName()}>
      <div className="charge-home__loading">
        Carregando ...
        <h4>{returnSubtitle()}</h4>
        <div className="charge-home__loading__banners" ref={bannersRef}>
          {banners.map((banner) => {
            if (banner.key.includes("arrow")) {
              return <img src={banner.image} alt={banner.alt} />;
            }

            return (
              <div key={banner.key}>
                <img src={banner.image} alt={banner.alt} />
              </div>
            );
          })}
        </div>
        <div className="charge-home__loading__container-bar">
          <div className="charge-home__loading__progress-bar">
            <div
              style={{
                width: `${widths[stepsLoading]}px`,
                transitionDuration: `${intervals[stepsLoading - 1]}s`,
              }}
              ref={progressBarRef}
            />
          </div>
          <div
            className="charge-home__loading__progress-bar-blur"
            style={{
              width: `${widths[stepsLoading]}px`,
              transitionDuration: `${intervals[stepsLoading - 1]}s`,
            }}
          />
        </div>
        <footer>
          Estamos estabelecendo a conexão entre os servidores da plataforma com
          a VIBRA e em segundos carregaremos uma página para que você possa
          visualizar todas as suas dívidas
        </footer>
      </div>
    </section>
  );
}
